import accountsSubCategory from './accountsSubCategory';
import attachmentsSubCategory from './attachmentsSubCategory';
import automaticRepliesSubCategory from './automaticRepliesSubCategory';
import brandsSubscriptionsSubCategory from './brandsSubscriptionsSubCategory';
import forwardingSubCategory from './forwardingSubCategory';
import handlingSubCategory from './handlingSubCategory';
import junkEmailSubCategory from './junkEmailSubCategory';
import layoutSubCategory from './layoutSubCategory';
import messageContentSubcategory from './messageContentSubcategory';
import rulesSubCategory from './rulesSubCategory';
import surfaceActionsSubCategory from './surfaceActionsSubCategory';
import sweepSubCategory from './sweepSubCategory';
import retentionPoliciesSubCategory from './retentionPoliciesSubCategory';
import { ControlIcons } from 'owa-control-icons';
import { OptionCategory } from 'owa-options-core';

let mailCategory: OptionCategory = {
    key: 'mail',
    titleStringKey: 'optionCategory_Mail',
    icon: ControlIcons.Mail,
    subcategories: [
        layoutSubCategory,
        messageContentSubcategory,
        attachmentsSubCategory,
        rulesSubCategory,
        sweepSubCategory,
        junkEmailSubCategory,
        surfaceActionsSubCategory,
        accountsSubCategory,
        handlingSubCategory,
        forwardingSubCategory,
        automaticRepliesSubCategory,
        brandsSubscriptionsSubCategory,
        retentionPoliciesSubCategory,
    ],
};

export default mailCategory;
